"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.tagPropType = exports.productTile = exports.pricePropType = exports.imagePropType = exports["default"] = exports.ctaPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var pricePropType = exports.pricePropType = _propTypes["default"].shape({
  value: _propTypes["default"].number,
  displayValue: _propTypes["default"].string
});
var ctaPropType = exports.ctaPropType = _propTypes["default"].shape({
  url: _propTypes["default"].string,
  label: _propTypes["default"].string
});
var imagePropType = exports.imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
var tagPropType = exports.tagPropType = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  label: _propTypes["default"].string
});
var productTile = exports.productTile = _propTypes["default"].shape({
  code: _propTypes["default"].string,
  price: pricePropType,
  vehicleImage: imagePropType,
  vehicleBackgroundImage: imagePropType,
  name: _propTypes["default"].string,
  cta: ctaPropType,
  buildLink: ctaPropType,
  tag: tagPropType
});
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  componentLabel: _propTypes["default"].string,
  productTile: _propTypes["default"].arrayOf(productTile),
  addPriceDisclaimer: _propTypes["default"].bool,
  priceDisclaimerId: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = exports["default"] = PROP_TYPES;